import { Tooltip } from '@douyinfe/semi-ui';
import styled from '@jupiter/plugin-runtime/styled';
import { IconEdit } from '@douyinfe/semi-icons';
import { useScope } from '@/hooks/useScope';

export const IconPost = () => {
  const scope = useScope();
  return (
    <Tooltip content={'发帖'} position={'left'}>
      <StyledIcoPost
        onClick={() => {
          if (window.Garfish) {
            window.open(`${window.location.origin}/forum/${scope}/post/new`);
          } else {
            window.open(`${window.location.origin}/${scope}/post/new`);
          }
        }}>
        <IconEdit />
      </StyledIcoPost>
    </Tooltip>
  );
};

const StyledIcoPost = styled.div`
  width: 48px;
  height: 48px;
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  border-radius: 100%;
  color: rgba(23, 26, 28, 0.65);
  right: 32px;
  bottom: 192px;
  cursor: pointer;
  filter: drop-shadow(0px 4px 14px rgba(0, 0, 0, 0.1));
  &:hover {
    color: #3c89ff;
  }
`;
